import { HIDE_SIDEBAR } from '../actionType/type';
import { getApiCall, putApiCall } from "../utils/request";
import { returnErrors } from "./errorAction";
import {
    GET_CURRENT_JOB, GET_ASPIRING_JOB, GET_SUGGESTED_ROLE, SAVE_CURRENT_JOB, GET_SUGGESTED_ROLE_SKILL, SAVE_ASPIRING_JOB,
    CLEAR_JOBS, GET_SUGGESTED_SKILL, CLOSE_SKILL_SUGGESTION, SAVE_PROFILE, SAVE_PROFILE1, SAVE_SKILLS
} from '../actionType/type';


export const hideSidebar = () => async (dispatch) => {
    return dispatch({
        type: HIDE_SIDEBAR,
    });
};

export const getCurrentJob = () => async (dispatch) => {
    try {
        const response = await getApiCall(`user/onboard/current`);
        dispatch({ type: GET_CURRENT_JOB, payload: response.data.current_job[0] });

    } catch (error) {
        returnErrors(dispatch, error.response?.data.message, error.response?.status)
    }
}

export const getAspiringJob = () => async (dispatch) => {
    try {
        const response = await getApiCall(`user/onboard/aspiring`);
        dispatch({ type: GET_ASPIRING_JOB, payload: response.data.aspiring_job[0] });

    } catch (error) {
        returnErrors(dispatch, error.response?.data.message, error.response?.status)
    }
}

export const getSuggestedRole = (val) => async (dispatch) => {
    try {
        const response = await getApiCall(`user/onboard/search/job?query=${val}`);
        dispatch({ type: GET_SUGGESTED_ROLE, payload: response.data.data });
    } catch (error) {
        returnErrors(dispatch, error.response?.data.message, error.response?.status)
    }
}

export const getSuggestedRoleSkills = (jobid, jobType) => async (dispatch) => {
    try {
        const response = await getApiCall(`user/onboard/job/skill?job_id=${jobid}`);
        const data = response.data.data[0]
        dispatch({ type: GET_SUGGESTED_ROLE_SKILL, payload: { data, jobType } });
    } catch (error) {
        returnErrors(dispatch, error.response?.data.message, error.response?.status)
    }
};

export const saveCurrentJob = (jobid) => async (dispatch) => {
    let obj = {
        current_job: jobid
    }
    try {
        const response = await putApiCall(`user/onboard/current`, obj);
        dispatch({ type: SAVE_CURRENT_JOB, });
    } catch (error) {
        returnErrors(dispatch, error.response?.data.message, error.response?.status)
    }
};


export const saveAspiringJob = (jobid) => async (dispatch) => {
    let obj = {
        aspiring_job: jobid
    }
    try {
        const response = await putApiCall(`user/onboard/aspiring`, obj);
        dispatch({ type: SAVE_ASPIRING_JOB, });
    } catch (error) {
        returnErrors(dispatch, error.response?.data.message, error.response?.status)
    }
};



export const clearJob = (type) => async (dispatch) => {
    return dispatch({
        type: CLEAR_JOBS, payload: type
    });
};

export const getSkillSuggestions = (val) => async (dispatch) => {
    try {
        const response = await getApiCall(`user/skill/search?query=${val}`);
        dispatch({ type: GET_SUGGESTED_SKILL, payload: response.data.data });
    } catch (error) {
        returnErrors(dispatch, error.response?.data.message, error.response?.status)
    }
}

export const closeSkillSuggestion = () => async (dispatch) => {
    return dispatch({
        type: CLOSE_SKILL_SUGGESTION,
    });
};

export const saveOtherSkills = (skills) => async (dispatch) => {
    let obj = {
        skills
    }
    try {
        const response = await putApiCall(`user/onboard/skill/add`, obj);
        if (response.data.success) {
            dispatch({ type: SAVE_SKILLS, });
        }
        else {
            returnErrors(dispatch, response?.data.message, response?.status)
        }
    } catch (error) {
        returnErrors(dispatch, error.response?.data.message, error.response?.status)
    }
};

export const saveProfile = (type) => async (dispatch) => {
    var obj
    if (type === 'profile') {
        obj = {
            profile_complete: true
        }
    }
    else if (type === 'skill') {
        obj = {
            skill_added: true
        }
    }
    else {
        obj = {
            intro_complete: true
        }
    }
    try {
        const response = await putApiCall(`user/onboard/intro`, obj);
        if (response.data.success) {
            dispatch({ type: SAVE_PROFILE, payload: type });
        }
        else {
            returnErrors(dispatch, response?.data.message, response?.status)
        }
    } catch (error) {
        returnErrors(dispatch, error.response?.data.message, error.response?.status)
    }

};

export const saveProfile1 = (type) => async (dispatch) => {
    var obj
    if (type === 'profile') {
        obj = {
            profile_complete: true
        }
    }
    else {
        obj = {
            intro_complete: true
        }
    }
    try {
        const response = await putApiCall(`user/onboard/intro`, obj);
        if (response.data.success) {
            dispatch({ type: SAVE_PROFILE1, payload: type });
        }
        else {
            returnErrors(dispatch, response?.data.message, response?.status)
        }
    } catch (error) {
        returnErrors(dispatch, error.response?.data.message, error.response?.status)
    }

};


